<template>
    <select v-if="!loading" v-model="selectedEmployee">
        <option
            v-for="employee in orderEmployees"
            :key="`${employee.employeeId}${employee.firstName}`"
            :value="employee.employeeId"
        >
            {{ employee.firstName }} {{ employee.lastName }}
        </option>
    </select>
</template>

<script>
export default {
    name: 'RockEmployeeSelection',
    props: ['value'],
    data() {
        return {
            loading: true,
            employees: []
        };
    },
    computed: {
        orderEmployees: function () {
            return this.employees
                .filter(({ active }) => active)
                .sort(function (a, b) {
                    if (a.firstName < b.firstName) return -1;
                    if (a.firstName > b.firstName) return 1;
                    return 0;
                });
        },

        selectedEmployee: {
            get() {
                return this.value && this.value.employeeId;
            },

            set(value) {
                const employee = this.employees.find(
                    ({ employeeId }) => employeeId === value
                );
                this.$emit('input', employee);
            }
        }
    },

    created() {
        this.getEmployees();
    },
    methods: {
        getEmployees() {
            const self = this;
            self.loading = true;
            return this.$http
                .get('employees')
                .then((response) => {
                    self.employees = response.data;
                    if (!self.selectedEmployee)
                        self.selectedEmployee = self.employees[0].employeeId;
                })
                .catch((error) => console.error(error))
                .finally(() => {
                    self.loading = false;
                });
        }
    }
};
</script>
